var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "svg",
    {
      class: _vm.classes,
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "17",
        height: "19",
        viewBox: "0 0 17 19",
        fill: "none",
      },
    },
    [
      _c("path", {
        staticClass: "fill-current",
        attrs: {
          d: "M3.5625 1.1875V2.375H1.78125C0.797852 2.375 0 3.17285 0 4.15625V5.9375H16.625V4.15625C16.625 3.17285 15.8271 2.375 14.8438 2.375H13.0625V1.1875C13.0625 0.530664 12.5318 0 11.875 0C11.2182 0 10.6875 0.530664 10.6875 1.1875V2.375H5.9375V1.1875C5.9375 0.530664 5.40684 0 4.75 0C4.09316 0 3.5625 0.530664 3.5625 1.1875ZM16.625 7.125H0V17.2188C0 18.2021 0.797852 19 1.78125 19H14.8438C15.8271 19 16.625 18.2021 16.625 17.2188V7.125Z",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }